import styled from 'vue-styled-components'
const WrapperProps = {
  position: {}
}
const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 7;
&::after {
position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border: 1px solid #ADDFFC;
  // background-color: rgba(244,252,255, 0.3);
  z-index: 4;
}
/* border: 3px solid red; */

.lbl-name {
  bottom: 100%;
  border-bottom: 0px;
}
// &.top {
//   .lbl-name {
//    bottom: 100%;
//   }
// }
// &.bottom {
//   .lbl-name {
//    top: 100%;
//   }
// }
`

const LegendProps = {
  indexCell: 0,
}

const Legend = styled('div', LegendProps)`
 pointer-events: auto;
position: absolute;
width: fit-content;
padding: 0px 10px;
left: ${({ indexCell }) => indexCell == 0 ? '54px' : '0px'};
/* border-radius: 0px 0px 4px 0px; */
background-color: #F4FCFF;
border: 1px solid #ADDFFC;
padding: 2px 12px 0px;
font-family: 'Roboto';
font-size: 12px;
line-height: 12px;
button.dropdown-toggle {
  color: #12A9FF;
  padding: 0px 10px;
  background: transparent !important;
  border: none !important;
  &.btn-secondary:not(:disabled):not(.disabled):focus {
    &:active {
      background: transparent !important;
      border: none !important;
    }
    &:focus {
      box-shadow: none;
    }
  }
}
`

export {
  Wrapper,
  Legend
}